import Vue from 'vue'
import ModalDialogs from 'vue-modal-dialogs'

// Initialization
Vue.use(ModalDialogs)


// WEBPACK FOOTER //
// ./src/providers/modals.js